/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Helpsupport1Inputs */

const he_nav_helpsupport1 = /** @type {(inputs: Nav_Helpsupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עזרה ותמיכה`)
};

const en_nav_helpsupport1 = /** @type {(inputs: Nav_Helpsupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help & Support`)
};

/**
* | output |
* | --- |
* | "Help & Support" |
*
* @param {Nav_Helpsupport1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const nav_helpsupport1 = /** @type {((inputs?: Nav_Helpsupport1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Helpsupport1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_nav_helpsupport1(inputs)
	return en_nav_helpsupport1(inputs)
});
export { nav_helpsupport1 as "nav_helpSupport" }